import type { override } from "cura-wasm/dist/types";

export function stringifyOverrides(overrides: override[]) {
  let string = "";
  overrides.forEach((o) => {
    string += "-s " + o.key + "=" + o.value + " ";
  });
  return string;
}
